import { 
  FileText, 
  FileSpreadsheet, 
  FileImage, 
  File as FileIcon,
  FileArchive,
  FileCode,
  LucideIcon
} from 'lucide-react';

/**
 * Format file size to human readable format
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
};

/**
 * Get file icon based on mime type
 */
export const getFileIcon = (mimeType: string): LucideIcon => {
  // Images
  if (mimeType.startsWith('image/')) {
    return FileImage;
  }
  
  // PDFs and Documents
  if (mimeType === 'application/pdf' || 
      mimeType === 'application/msword' ||
      mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    return FileText;
  }
  
  // Spreadsheets
  if (mimeType === 'application/vnd.ms-excel' ||
      mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      mimeType === 'text/csv') {
    return FileSpreadsheet;
  }
  
  // Archives
  if (mimeType === 'application/zip' ||
      mimeType === 'application/x-zip-compressed' ||
      mimeType === 'application/x-rar-compressed' ||
      mimeType === 'application/x-7z-compressed' ||
      mimeType === 'application/gzip' ||
      mimeType === 'application/x-tar') {
    return FileArchive;
  }
  
  // Code files
  if (mimeType === 'text/plain' ||
      mimeType === 'application/json' ||
      mimeType === 'text/html' ||
      mimeType === 'text/css' ||
      mimeType === 'text/javascript') {
    return FileCode;
  }
  
  // Default
  return FileIcon;
};

/**
 * Get file extension from filename
 */
export const getFileExtension = (filename: string): string => {
  const parts = filename.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : '';
};

/**
 * Get file color based on mime type
 */
export const getFileColor = (mimeType: string): string => {
  if (mimeType.startsWith('image/')) return 'text-blue-600';
  if (mimeType === 'application/pdf') return 'text-red-600';
  if (mimeType.includes('word')) return 'text-blue-700';
  if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'text-green-600';
  if (mimeType.includes('powerpoint') || mimeType.includes('presentation')) return 'text-orange-600';
  if (mimeType.includes('zip') || mimeType.includes('rar') || mimeType.includes('7z')) return 'text-purple-600';
  return 'text-gray-600';
};
